export default __webpack_public_path__ + "static/media/AddItem.859715ed.png";